import React, { useEffect, useRef } from 'react';

function AuthModal({ title, children, onClose, icon, firstInputRef }) {
  const closeButtonRef = useRef(null);

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    } else if (e.key === 'Tab') {
      const focusableElements = Array.from(e.currentTarget.querySelectorAll('input, button, a'));
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          closeButtonRef.current.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      }
    }
  };

  useEffect(() => {
    if (firstInputRef && firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, [firstInputRef]);

  return (
    <div className="modal-overlay" onKeyDown={handleKeyDown}>
      <div className="modal-content">
        <div className="modal-header">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {icon && <i className="material-icons" style={{ marginRight: '10px' }}>{icon}</i>}
            <h2>{title}</h2>
          </div>
          <button ref={closeButtonRef} title="Close" onClick={onClose} className="icon-button close-button">
            <i className="material-icons">close</i>
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}

export default AuthModal;
